// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"456":"c87a288b","477":"c87a288b","543":"c87a288b","702":"235fc459"}[chunkId] + ".chunk.css";
};